import type { CeremonyStep, WeddingData } from '@/mock/types'

export function ceremonyPeople(data: WeddingData) {
  return [
    ...data.members.map((member) => ({
      person: { type: 'member', id: member.id } satisfies CeremonyStep['people'][number],
      name: member.name,
      category: 'Svatební tým',
    })),
    ...data.parties.flatMap((party) =>
      party.persons
        .filter((guest) => guest.firstName.trim() || guest.lastName.trim())
        .map((guest) => ({
          person: { type: 'guest', id: guest.id } satisfies CeremonyStep['people'][number],
          name: `${guest.firstName} ${guest.lastName}`.trim(),
          category: 'Hosté',
        })),
    ),
    ...data.suppliers
      .filter((supplier) => supplier.status !== 'cancelled')
      .map((supplier) => ({
        person: { type: 'supplier', id: supplier.id } satisfies CeremonyStep['people'][number],
        name: supplier.name,
        category: 'Dodavatelé',
      })),
  ]
}

export function personKey(person: CeremonyStep['people'][number]) {
  return `${person.type}:${person.id}`
}
